import NProgress from 'nprogress'

const afterEach = (to, from, next) => {
  // console.log(to, from)
  NProgress.done();
};
export default afterEach;



// WEBPACK FOOTER //
// ./src/router/afterEach.js